/* istanbul ignore file */

import { FieldIdentifier } from './field-identifier';
import { FormulaMapping } from './logic-builder';
import { FieldStyleEvaluatedAction } from './logic-builder/field-style-evaluated-action';

export class EvaluatedSiteProperties {
    fieldStyleEvaluatedActions: FieldStyleEvaluatedAction[] = [];
    fieldsSettableByLogicBuilders: FieldIdentifier[] = [];
    triggerFields: FieldIdentifier[] = [];
    mapPinColorsByProject: Map<string, number> = new Map<string, number>();
    fetchedEvaluatedLogicBuilderFormulaFieldsAssociatedToSite: Map<string, boolean> = new Map<string, boolean>();
    formulaOperands: FieldIdentifier[] = [];
    formulaMappings: FormulaMapping[] = [];
}
